import { render } from "./Simulate.vue?vue&type=template&id=06d1a454&scoped=true"
import script from "./Simulate.vue?vue&type=script&lang=js"
export * from "./Simulate.vue?vue&type=script&lang=js"

import "./Simulate.vue?vue&type=style&index=0&id=06d1a454&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06d1a454"

export default script